import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserProfileResponse } from '../../../types/common/AuthType';
import AuthApi from '../../../lib/api/auth/AuthApi';
import { QueryOptions } from '../../../types/query/useQuery';

interface IUseUserProfileParams<SelectResultType> {
  options: QueryOptions<{ data: UserProfileResponse }, Error, SelectResultType>;
}

const useUserProfile = <SelectResultType>(
  props: IUseUserProfileParams<SelectResultType>,
): UseQueryResult<SelectResultType, Error> => {
  const { options } = props;
  return useQuery<{ data: UserProfileResponse }, Error, SelectResultType>(
    ['fetchProfile'],
    () => AuthApi.fetchProfile(),
    {
      ...options,
    },
  );
};

export default useUserProfile;
